import { GenericForm, GenericFormLogicalField, genericBeforeValidate_removeDefaultKeyedError, genericValidate_textField, ValidationEvent } from "../../../hooks";

export const maxGiftcardPinLength = 4;

interface GiftcardPinFormLogicProps {
  required?: boolean;
}

export const giftcardPinFormLogic = <
  Form extends GenericForm,
  App extends unknown
>({ required }: GiftcardPinFormLogicProps = {}): GenericFormLogicalField<
  Form,
  App
> => ({
  validationEvents: [
    ValidationEvent.onChange,
    ValidationEvent.onBlur,
    ValidationEvent.onSubmit,
  ],
  beforeValidate: genericBeforeValidate_removeDefaultKeyedError,
  validate: genericValidate_textField({
    required,
    trim: true,
    maxLength: maxGiftcardPinLength,
  }),
});
